import { FormActionButton } from '@workwave-tidal/core/form'

import { form } from '../../formState'

import { useTexts } from './useTexts'

interface Props {
  onTest: () => void
  onCancel: () => void
}

export function Footer(props: Props) {
  const { onCancel, onTest } = props
  const texts = useTexts()

  const {
    api: { reset },
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  const saveDisabled = status === 'pristine' || validating || submitting
  const resetDisabled = status === 'pristine' || submitting

  const onReset = () => {
    reset('force')
  }

  return (
    <>
      <FormActionButton
        label={texts.cancel}
        size="medium"
        testId="footer-secondary-button"
        data-trackid="footer-secondary-button"
        onClick={onCancel}
      />
      <FormActionButton
        label={texts.reset}
        size="medium"
        testId="footer-reset-button"
        data-trackid="footer-reset-button"
        onClick={onReset}
        disabled={resetDisabled}
      />
      <FormActionButton
        label={texts.test}
        size="medium"
        testId="footer-test-button"
        data-trackid="footer-test-button"
        onClick={onTest}
        disabled={submitting}
      />
      <FormActionButton
        size="medium"
        type="submit"
        label={texts.save}
        testId="footer-primary-button"
        data-trackid="footer-primary-button"
        variant="contained"
        loading={submitting || validating}
        disabled={saveDisabled}
      />
    </>
  )
}
